module.exports = __webpack_public_path__ + "static/media/greater-than-equal.9043d450.svg";